const pathMatches = (pathname, root) => pathname === root || pathname.startsWith(`${root}/`);

export const isEditorialSurface = (pathname = '') =>
  pathname === '/' || pathMatches(pathname, '/manifesto') || pathMatches(pathname, '/black-star-signal') || pathMatches(pathname, '/field-archive');

export const isPassportSurface = (pathname = '') => pathMatches(pathname, '/passport') || pathMatches(pathname, '/gig-passport');

export const isOperatorSurface = (pathname = '') => pathMatches(pathname, '/operator') || pathMatches(pathname, '/admin');

export const isFieldSurface = (pathname = '') =>
  pathMatches(pathname, '/signal') ||
  pathMatches(pathname, '/field') ||
  pathMatches(pathname, '/card') ||
  pathMatches(pathname, '/qr-card') ||
  pathMatches(pathname, '/story') ||
  pathMatches(pathname, '/147th') ||
  pathMatches(pathname, '/harlem-147th') ||
  pathMatches(pathname, '/147th-street') ||
  pathMatches(pathname, '/rxafrica') ||
  pathMatches(pathname, '/rx-africa') ||
  pathMatches(pathname, '/africa-rx');

export const isIsolatedSurface = (pathname = '') =>
  isEditorialSurface(pathname) ||
  isPassportSurface(pathname) ||
  isOperatorSurface(pathname) ||
  isFieldSurface(pathname);
